import { push } from "connected-react-router";
import { isMobile } from "react-device-detect";
import { isEmpty } from "react-redux-firebase";
import { LOADING_SCREEN_HIDE, LOADING_SCREEN_SHOW, MODAL_HIDE, MODAL_SHOW, MODAL_TYPE_ERROR, MODAL_TYPE_SUCCESS, PROFILE_HIDE, SET_CLAIM_DATA, SET_CUSTOMER_DATA, SET_SELF_INSPECT_DATA, SET_TEMPLATE_DATA } from "../constants/constants";
import { ERROR_HEADER, ERROR_INSPECTION_PHOTOS } from "../constants/copy";
import { CAPTURE_IMAGES, SUBMIT_CLAIM_DETAILS } from "../routes/routes";
import { logErrorToDatabase, postToController } from "./apiActions";
import { showContinueOnPhone } from "./modalActions";

export const setPolcyAndType = (userData: any) => {
    return async (dispatch) => {

        dispatch({
            type: SET_TEMPLATE_DATA, payload: {
                step: userData
            }
        });
    }
}

export const setStep = (step: number, subStep: 1) => {
    return async (dispatch) => {
        dispatch({
            type: SET_TEMPLATE_DATA, payload: {
                step: step,
                subStep: subStep
            }
        });
    }
}

export const setNextStep = (step: number, subStep: 1) => {
    return async (dispatch) => {
        dispatch({
            type: SET_TEMPLATE_DATA, payload: {
                nextStep: step,
                nextSubStep: subStep
            }
        });
    }
}

export const handleNextStep = () => {
    return async (dispatch, getState) => {
        
        let nextStep = getState().TemplateData.step;
        let nextSubStep = getState().TemplateData.subStep;
        let currentStep = getState().TemplateData.step;
        if ((getState().TemplateData.stepConfiguration.steps[currentStep - 1].maxSubSteps <= getState().FNOL.fnolSubStep && !isMobile) || (getState().FNOL.fnolStepConfiguration.steps[currentStep - 1].maxMobileSubSteps <= getState().FNOL.fnolSubStep && isMobile)) {

            nextSubStep = 1;
            nextStep++;
        }
        else {
            nextSubStep++;
        }
        if ((getState().TemplateData.stepConfiguration.steps[nextStep - 1].maxMobileSubSteps == 0 && isMobile)) {
            while ((getState().TemplateData.stepConfiguration.steps[nextStep - 1].maxMobileSubSteps == 0 && isMobile)) {
                nextStep++;
                if (nextStep > 50) {
                    break;
                }
            }
        }
        if ((getState().TemplateData.stepConfiguration.steps[nextStep - 1].maxSubSteps == 0 && !isMobile)) {
            while ((getState().TemplateData.stepConfiguration.steps[nextStep - 1].maxSubSteps == 0 && !isMobile)) {
                nextStep++;
                if (nextStep > 50) {
                    break;
                }
            }
        }
        dispatch(setStep(nextStep, nextSubStep));
    }
}

export const handleStepBack = () => {
    return async (dispatch, getState) => {
        let nextStep = getState().TemplateData.step;
        let nextSubStep = getState().TemplateData.subStep;
        let currentStep = getState().TemplateData.step;
        if (nextSubStep === 1) {
            nextSubStep = (!isMobile ? getState().TemplateData.stepConfiguration.steps[currentStep - 2].maxSubSteps : getState().TemplateData.stepConfiguration.steps[currentStep - 2].maxMobileSubSteps);
            nextStep--;
        }
        else {
            nextSubStep--;
        }
        dispatch(setStep(nextStep, nextSubStep));
        if (nextSubStep === 0) {
            handleStepBack();
        }
    }
}


